module.exports = __webpack_public_path__ + "static/46-1fdfc42daab7b902622b53d7a12868ef.jpg";